import { isNil } from 'lodash';
import { RouteStep } from '~/routes/calculations/types';
import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(ownProps: OwnProps) {
  const { currentProperty } = ownProps;

  const address = currentProperty?.address;

  if (isNil(address)) {
    return false;
  }

  const rce =
    currentProperty?.replacementCost || currentProperty?.replacementCostEstimateCalculation;

  if (isNil(rce)) {
    return false;
  }

  return true;
}

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/home-coverages',
  isAccessible: ({ application, currentProperty }: OwnProps) =>
    !currentProperty.newPurchase && !application.isAutoOnly,
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
